import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { KycFieldPurpose } from '../api/types';

const useKycPresetOptions = () => {
    const { t } = useTranslation('localCustomerModuleDetails');

    return useMemo(() => {
        const purposeOptions = [
            {
                value: KycFieldPurpose.Kyc,
                label: t('localCustomerModuleDetails:options.purpose.kyc'),
            },
            {
                value: KycFieldPurpose.Share,
                label: t('localCustomerModuleDetails:options.purpose.share'),
            },
        ];

        return {
            purposeOptions,
        };
    }, [t]);
};

export default useKycPresetOptions;
